var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDahsboardLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 3.99992C1.33325 2.52716 2.52716 1.33325 3.99992 1.33325H9.33325C10.806 1.33325 11.9999 2.52716 11.9999 3.99992V9.33325C11.9999 10.806 10.806 11.9999 9.33325 11.9999H3.99992C2.52716 11.9999 1.33325 10.806 1.33325 9.33325V3.99992Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 3.99992C19.9999 2.52716 21.1938 1.33325 22.6666 1.33325H27.9999C29.4727 1.33325 30.6666 2.52716 30.6666 3.99992V9.33325C30.6666 10.806 29.4727 11.9999 27.9999 11.9999H22.6666C21.1938 11.9999 19.9999 10.806 19.9999 9.33325V3.99992Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 22.6666C1.33325 21.1938 2.52716 19.9999 3.99992 19.9999H9.33325C10.806 19.9999 11.9999 21.1938 11.9999 22.6666V27.9999C11.9999 29.4727 10.806 30.6666 9.33325 30.6666H3.99992C2.52716 30.6666 1.33325 29.4727 1.33325 27.9999V22.6666Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.6666C19.9999 21.1938 21.1938 19.9999 22.6666 19.9999H27.9999C29.4727 19.9999 30.6666 21.1938 30.6666 22.6666V27.9999C30.6666 29.4727 29.4727 30.6666 27.9999 30.6666H22.6666C21.1938 30.6666 19.9999 29.4727 19.9999 27.9999V22.6666Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDahsboardLight);
export default __webpack_public_path__ + "static/media/dahsboard-light.1696610f9cd63fe7a5508ddb191bc211.svg";
export { ForwardRef as ReactComponent };